{
    "name": "partnehubweb",
    "version": "1.67.1",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "build:stg": "node --max_old_space_size=4096 node_modules/@angular/cli/bin/ng build --configuration staging --aot --output-hashing=all",
        "build:prod": "node --max_old_space_size=4096 node_modules/@angular/cli/bin/ng build --configuration production --aot --output-hashing=all",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "lint": "ng lint"
    },
    "private": true,
    "dependencies": {
        "@amplitude/analytics-browser": "^2.12.0",
        "@analytics/core": "^0.12.17",
        "@analytics/google-analytics": "^1.1.0",
        "@angular/animations": "^18.0.0",
        "@angular/cdk": "^18.0.5",
        "@angular/common": "^18.0.0",
        "@angular/compiler": "^18.0.0",
        "@angular/core": "^18.0.0",
        "@angular/forms": "^18.0.0",
        "@angular/material": "^18.0.5",
        "@angular/platform-browser": "^18.0.0",
        "@angular/platform-browser-dynamic": "^18.0.0",
        "@angular/router": "^18.0.0",
        "@ng-bootstrap/ng-bootstrap": "^17.0.0",
        "@popperjs/core": "^2.11.8",
        "@types/event-source-polyfill": "^1.0.5",
        "ace-builds": "^1.35.2",
        "angular-svg-icon": "^18.0.1",
        "angular2-uuid": "^1.1.1",
        "apexcharts": "^4.1.0",
        "bootstrap": "^5.3.2",
        "canvas-confetti": "^1.9.3",
        "event-source-polyfill": "^1.0.31",
        "exceljs": "^4.4.0",
        "file-saver": "^2.0.5",
        "font-awesome": "^4.7.0",
        "html-to-image": "^1.11.11",
        "jspdf": "^3.0.1",
        "marked": "^12.0.2",
        "moment": "^2.30.1",
        "ng-apexcharts": "~1.13.0",
        "ng-recaptcha-2": "^14.0.0",
        "ng2-currency-mask": "^13.0.3",
        "ng2-pdf-viewer": "^10.2.2",
        "ngx-clipboard": "^16.0.0",
        "ngx-markdown": "^18.0.0",
        "ngx-markdown-editor": "^5.3.4",
        "ngx-mask": "^17.0.8",
        "ngx-skeleton-loader": "^9.0.0",
        "ngx-toastr": "^19.0.0",
        "papaparse": "^5.4.1",
        "rxjs": "~7.8.0",
        "tslib": "^2.3.0",
        "zone.js": "~0.14.3"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^18.0.6",
        "@angular/cli": "^18.0.6",
        "@angular/compiler-cli": "^18.0.0",
        "@angular/localize": "^18.0.0",
        "@types/canvas-confetti": "^1.6.4",
        "@types/exceljs": "^1.3.0",
        "@types/file-saver": "^2.0.7",
        "@types/jasmine": "~5.1.0",
        "@types/node": "^20.14.9",
        "@types/papaparse": "^5.3.14",
        "angular-eslint": "18.1.0",
        "cypress": "^13.13.0",
        "eslint": "^9.6.0",
        "eslint-plugin-cypress": "^3.4.0",
        "jasmine-core": "~5.1.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "prettier": "3.3.2",
        "typescript": "~5.4.2",
        "typescript-eslint": "8.0.0-alpha.38"
    }
}
